// @flow
import React, { Component, type ComponentType } from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import { MuiThemeProvider, createMuiTheme, withStyles } from "@material-ui/core/styles";
import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";
import { Content, Label1, Label2, Form } from "./styled";

const theme = createMuiTheme({
    palette: {
        primary: blue,
        secondary: green
    },
    status: {
        danger: "orange"
    }
});

type Props = { userInfo: ComponentType<any>, onLogin: Function };

class PasswordView extends Component<Props> {
    render() {
        const { userInfo, onLogin } = this.props;
        return (
            <MuiThemeProvider theme={theme}>
                <Content>
                    <Form>
                        <TextField
                            error={userInfo[0].blogPassword === "fail"}
                            id="blog-password-input"
                            label={
                                userInfo[0].blogPassword === "fail"
                                    ? "Incorrect Password"
                                    : "Password"
                            }
                            type="password"
                            autoComplete="current-password"
                            margin="normal"
                        />

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() =>
                                onLogin(document.getElementById("blog-password-input").value)
                            }
                        >
                            View Blog
                        </Button>
                    </Form>
                    <Label1>This is a private blog</Label1>
                    <Label2>Contact the author for the password</Label2>
                </Content>
            </MuiThemeProvider>
        );
    }
}

export default withStyles(theme)(PasswordView);



// WEBPACK FOOTER //
// ./src/home-page-view/password-view/view.js